import { Text, View } from "@react-pdf/renderer";
import styles from '../styles/styles';

interface ElementProps {
  label: string;
  data: string | null | undefined;
}

const Element = ({ label, data }: ElementProps) => {
  if (data === undefined) return null;

  return (
    <View style={styles.column}>
      <Text style={styles.label}>{label}:</Text>
      <Text>{data}</Text>
    </View>
  );
}

export default Element;